import React from "react";
import {
    Box,
    Container,
    Heading,
    Text,
    HStack,
    Icon,
    Badge,
    Avatar
} from "@chakra-ui/react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaStar } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";

const Testimonials = () => {
    const { t } = useLanguage();

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    const reviews = t("testimonials.reviews");
    const reviewsList = Array.isArray(reviews) ? reviews : [];

    return (
        <Box py={{ base: 14, md: 20 }} bg="white" position="relative" overflow="hidden">
            <Container maxW="container.xl" px={{ base: 4, md: 8 }}>
                <Box textAlign="center" maxW="700px" mx="auto" mb={{ base: 10, md: 14 }}>
                    <Badge
                        bg="brand.50"
                        color="brand.600"
                        px={3.5}
                        py={1.5}
                        borderRadius="full"
                        fontSize="xs"
                        fontWeight="700"
                        mb={3}
                        letterSpacing="0.05em"
                    >
                        {t("testimonials.badge")}
                    </Badge>
                    <Heading
                        fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
                        fontWeight="800"
                        color="gray.900"
                        letterSpacing="-0.02em"
                    >
                        {t("testimonials.title")}
                    </Heading>
                    <Text color="gray.500" fontSize={{ base: "sm", md: "md" }} mt={3}>
                        {t("testimonials.subtitle")}
                    </Text>
                </Box>

                <Slider {...sliderSettings}>
                    {reviewsList.map((review, idx) => (
                        <Box key={idx} px={{ base: 2, md: 3 }} py={2}>
                            <Box
                                bg="#f8fafc"
                                p={{ base: 6, md: 8 }}
                                borderRadius="2xl"
                                border="1px solid"
                                borderColor="gray.100"
                                boxShadow="0 4px 20px rgba(0, 0, 0, 0.04)"
                                minH="240px"
                                display="flex"
                                flexDirection="column"
                                justifyContent="space-between"
                                transition="all 0.3s ease"
                                _hover={{
                                    transform: "translateY(-4px)",
                                    boxShadow: "0 12px 30px rgba(0, 0, 0, 0.08)",
                                    borderColor: "brand.200",
                                }}
                            >
                                <Box>
                                    <HStack spacing={1} mb={4} color="#dfba73">
                                        {[...Array(review.rating || 5)].map((_, i) => (
                                            <Icon key={i} as={FaStar} fontSize="14px" />
                                        ))}
                                    </HStack>
                                    <Text
                                        fontSize={{ base: "sm", md: "md" }}
                                        color="gray.700"
                                        lineHeight="1.7"
                                        fontStyle="italic"
                                        mb={6}
                                    >
                                        "{review.quote}"
                                    </Text>
                                </Box>

                                <HStack spacing={3}>
                                    <Avatar
                                        name={review.author}
                                        size="sm"
                                        bg="brand.600"
                                        color="white"
                                        fontWeight="bold"
                                    />
                                    <Box>
                                        <Text fontWeight="700" fontSize="sm" color="gray.900">
                                            {review.author}
                                        </Text>
                                        <Text fontSize="xs" color="gray.500">
                                            {review.role}
                                        </Text>
                                    </Box>
                                </HStack>
                            </Box>
                        </Box>
                    ))}
                </Slider>
            </Container>
        </Box>
    );
};

export default Testimonials;